import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import GetTaskModel from '../../../projects/click-up-api/i-service/models/request/GetTaskModel';
import TaskIdModel from '../../../projects/click-up-api/i-service/models/request/TaskIdModel';
import CreateTaskModel from '../../../projects/click-up-api/i-service/models/request/CreateTaskModel';
import UpdateTaskModel from '../../../projects/click-up-api/i-service/models/request/UpdateTaskModel';
import UpdateCommentTask from '../../../projects/click-up-api/i-service/models/request/UpdateCommentTask';
import ImportAttachmentModel from '../../../projects/click-up-api/i-service/models/ImportAttachmentModel';
import ListIdModel from '../../../projects/click-up-api/i-service/models/request/ListIdModel';
import GetStatusModel from '../../../projects/click-up-api/i-service/models/request/GetStatusModel';
import UpdateTaskStatusModel from '../../../projects/click-up-api/i-service/models/request/UpdateTaskStatusModel';
import UpdateTaskPriorityRequest from '../../../projects/click-up-api/i-service/models/request/UpdateTaskPriorityRequest';
import GetTaskByTagModel from '../../../projects/click-up-api/i-service/models/request/GetTaskByTagModel';
import CreateCommentTaskModel from '../../../projects/click-up-api/i-service/models/request/CreateCommentTaskModel';
import GetCommentsModel from '../../../projects/click-up-api/i-service/models/request/GetCommentsModel';
import TeamIdModel from '../../../projects/click-up-api/i-service/models/request/TeamIdModel';
import CreateFolderModel from '../../../projects/click-up-api/i-service/models/request/CreateFolderModel';
import TagModel from '../../../projects/click-up-api/i-service/models/response/model/TagModel';
import SpaceIdModel from '../../../projects/click-up-api/i-service/models/request/SpaceIdModel';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import TaskCreateResponse from '../../../projects/task/i-service/models/task/response/TaskCreateResponse';
import DeletedTaskModel from '../../../projects/click-up-api/i-service/models/response/model/DeletedTaskModel';
import CreatedTaskModel from '../../../projects/click-up-api/i-service/models/response/model/CreatedTaskModel';
import SpacesModel from '../../../projects/click-up-api/i-service/models/response/lists/SpacesModel';
import ListsModel from '../../../projects/click-up-api/i-service/models/response/lists/ListsModel';
import PriorityModel from '../../../projects/click-up-api/i-service/models/response/model/PriorityModel';
import StatusesModel from '../../../projects/click-up-api/i-service/models/response/lists/StatusesModel';
import TaskModel from '../../../projects/click-up-api/i-service/models/response/model/TaskModel';
import StatusModel from '../../../projects/click-up-api/i-service/models/response/model/StatusModel';
import AttachmentsModel from '../../../projects/click-up-api/i-service/models/response/lists/AttachmentsModel';
import UpdatePriorityResponse from '../../../projects/click-up-api/i-service/models/response/model/UpdatePriorityResponse';
import SubtasksModel from '../../../projects/click-up-api/i-service/models/response/lists/SubtasksModel';
import TasksModel from '../../../projects/click-up-api/i-service/models/response/lists/TasksModel';
import CreatedCommentModel from '../../../projects/click-up-api/i-service/models/response/model/CreatedCommentModel';
import CommentsModel from '../../../projects/click-up-api/i-service/models/response/lists/CommentsModel';
import UsersModel from '../../../projects/click-up-api/i-service/models/response/lists/UsersModel';
import TagsModel from '../../../projects/click-up-api/i-service/models/response/lists/TagsModel';

export default class ServiceClickUpRestApi {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	ImportTaskFromClickUpAsyncEvent = new Events<WsResponseModelT<TaskCreateResponse>>();
	DeleteTaskAsyncEvent = new Events<WsResponseModelT<DeletedTaskModel>>();
	CreateTaskAsyncEvent = new Events<WsResponseModelT<CreatedTaskModel>>();
	UpdateFullTaskAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	GetAllSpacesAsyncEvent = new Events<WsResponseModelT<SpacesModel>>();
	GetAllListsAsyncEvent = new Events<WsResponseModelT<ListsModel>>();
	UpdateCommentAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	ImportAttachmentFromClickUpAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	GetPriorityByTaskIdAsyncEvent = new Events<WsResponseModelT<PriorityModel>>();
	GetStatusesByTaskIdAsyncEvent = new Events<WsResponseModelT<StatusesModel>>();
	GetClickUpPrioritiesEvent = new Events<WsResponseModelT<Array<PriorityModel>>>();
	GetStatusesByListIdAsyncEvent = new Events<WsResponseModelT<StatusesModel>>();
	GetClickUpTaskAsyncEvent = new Events<WsResponseModelT<TaskModel>>();
	GetStatusTaskEvent = new Events<WsResponseModelT<StatusModel>>();
	GetAttachmentsTaskAsyncEvent = new Events<WsResponseModelT<AttachmentsModel>>();
	UpdateTaskStatusAsyncEvent = new Events<WsResponseModelT<StatusModel>>();
	UpdateTaskPriorityAsyncEvent = new Events<WsResponseModelT<UpdatePriorityResponse>>();
	UpdateTaskStatusAndPriorityEvent = new Events<WsResponseModelT<Boolean>>();
	GetSubtasksAsyncEvent = new Events<WsResponseModelT<SubtasksModel>>();
	GetTaskByTagAsyncEvent = new Events<WsResponseModelT<TasksModel>>();
	CreateCommentTaskAsyncEvent = new Events<WsResponseModelT<CreatedCommentModel>>();
	GetTasksListAsyncEvent = new Events<WsResponseModelT<TasksModel>>();
	GetCommentsTaskAsyncEvent = new Events<WsResponseModelT<CommentsModel>>();
	GetAllTasksAsyncEvent = new Events<WsResponseModelT<TasksModel>>();
	GetTasksTeamAsyncEvent = new Events<WsResponseModelT<TasksModel>>();
	GetMembersTaskAsyncEvent = new Events<WsResponseModelT<UsersModel>>();
	CreateFolderSpaceAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	CreateTagSpaceAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	GetTagsSpaceAsyncEvent = new Events<WsResponseModelT<TagsModel>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ServiceClickUpRestApi', 'ImportTaskFromClickUpAsync', 'Main', (res: WsResponseModelT<TaskCreateResponse>) => {
			self.ImportTaskFromClickUpAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'DeleteTaskAsync', 'Main', (res: WsResponseModelT<DeletedTaskModel>) => {
			self.DeleteTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'CreateTaskAsync', 'Main', (res: WsResponseModelT<CreatedTaskModel>) => {
			self.CreateTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'UpdateFullTaskAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateFullTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetAllSpacesAsync', 'Main', (res: WsResponseModelT<SpacesModel>) => {
			self.GetAllSpacesAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetAllListsAsync', 'Main', (res: WsResponseModelT<ListsModel>) => {
			self.GetAllListsAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'UpdateCommentAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateCommentAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'ImportAttachmentFromClickUpAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.ImportAttachmentFromClickUpAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetPriorityByTaskIdAsync', 'Main', (res: WsResponseModelT<PriorityModel>) => {
			self.GetPriorityByTaskIdAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetStatusesByTaskIdAsync', 'Main', (res: WsResponseModelT<StatusesModel>) => {
			self.GetStatusesByTaskIdAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetClickUpPriorities', 'Main', (res: WsResponseModelT<Array<PriorityModel>>) => {
			self.GetClickUpPrioritiesEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetStatusesByListIdAsync', 'Main', (res: WsResponseModelT<StatusesModel>) => {
			self.GetStatusesByListIdAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetClickUpTaskAsync', 'Main', (res: WsResponseModelT<TaskModel>) => {
			self.GetClickUpTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetStatusTask', 'Main', (res: WsResponseModelT<StatusModel>) => {
			self.GetStatusTaskEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetAttachmentsTaskAsync', 'Main', (res: WsResponseModelT<AttachmentsModel>) => {
			self.GetAttachmentsTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'UpdateTaskStatusAsync', 'Main', (res: WsResponseModelT<StatusModel>) => {
			self.UpdateTaskStatusAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'UpdateTaskPriorityAsync', 'Main', (res: WsResponseModelT<UpdatePriorityResponse>) => {
			self.UpdateTaskPriorityAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'UpdateTaskStatusAndPriority', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateTaskStatusAndPriorityEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetSubtasksAsync', 'Main', (res: WsResponseModelT<SubtasksModel>) => {
			self.GetSubtasksAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetTaskByTagAsync', 'Main', (res: WsResponseModelT<TasksModel>) => {
			self.GetTaskByTagAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'CreateCommentTaskAsync', 'Main', (res: WsResponseModelT<CreatedCommentModel>) => {
			self.CreateCommentTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetTasksListAsync', 'Main', (res: WsResponseModelT<TasksModel>) => {
			self.GetTasksListAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetCommentsTaskAsync', 'Main', (res: WsResponseModelT<CommentsModel>) => {
			self.GetCommentsTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetAllTasksAsync', 'Main', (res: WsResponseModelT<TasksModel>) => {
			self.GetAllTasksAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetTasksTeamAsync', 'Main', (res: WsResponseModelT<TasksModel>) => {
			self.GetTasksTeamAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetMembersTaskAsync', 'Main', (res: WsResponseModelT<UsersModel>) => {
			self.GetMembersTaskAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'CreateFolderSpaceAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.CreateFolderSpaceAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'CreateTagSpaceAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.CreateTagSpaceAsyncEvent.trigger(res);
		});
		webApiService.on('ServiceClickUpRestApi', 'GetTagsSpaceAsync', 'Main', (res: WsResponseModelT<TagsModel>) => {
			self.GetTagsSpaceAsyncEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Получение задачи по ее номеру и загрузка на пм
	 */
	async ImportTaskFromClickUpAsync(model: GetTaskModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'ImportTaskFromClickUpAsync',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление задачи c clickup и пм
	 */
	async DeleteTaskAsync(taskId: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'DeleteTaskAsync',
			Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание задачи на clickup и пм
	 */
	async CreateTaskAsync(model: CreateTaskModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'CreateTaskAsync',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление задачи
	 */
	async UpdateFullTaskAsync(parameters: UpdateTaskModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'UpdateFullTaskAsync',
			Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение всех пространств
	 */
	async GetAllSpacesAsync() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetAllSpacesAsync',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение всех списков в которых распологаются задачи
	 */
	async GetAllListsAsync() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetAllListsAsync',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменяет текст комментария
	 */
	async UpdateCommentAsync(newComment: UpdateCommentTask) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'UpdateCommentAsync',
			Value: typeof(newComment) === 'object' ? JSON.stringify(newComment) : newComment,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление вложения на пм
	 */
	async ImportAttachmentFromClickUpAsync(model: ImportAttachmentModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'ImportAttachmentFromClickUpAsync',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение приоритета задачи
	 */
	async GetPriorityByTaskIdAsync(model: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetPriorityByTaskIdAsync',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение статусов по номеру задачи
	 */
	async GetStatusesByTaskIdAsync(task: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetStatusesByTaskIdAsync',
			Value: typeof(task) === 'object' ? JSON.stringify(task) : task,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получения всех приоритетов сайта clickup
	 */
	async GetClickUpPriorities() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetClickUpPriorities',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение статусов списка
	 */
	async GetStatusesByListIdAsync(list: ListIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetStatusesByListIdAsync',
			Value: typeof(list) === 'object' ? JSON.stringify(list) : list,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение задачи clickup с номерами статуса, приоритета и самой задачи
	 */
	async GetClickUpTaskAsync(taskId: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetClickUpTaskAsync',
			Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение статуса задачи
	 */
	async GetStatusTask(model: GetStatusModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetStatusTask',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение вложений задачи
	 */
	async GetAttachmentsTaskAsync(model: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetAttachmentsTaskAsync',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновляет статус задачи
	 */
	async UpdateTaskStatusAsync(parameters: UpdateTaskStatusModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'UpdateTaskStatusAsync',
			Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменение приоритета задачи
	 */
	async UpdateTaskPriorityAsync(parameters: UpdateTaskPriorityRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'UpdateTaskPriorityAsync',
			Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление статуса и приоритета задачи на пм(изменения применяются если они присутствуют на clickup)
	 */
	async UpdateTaskStatusAndPriority(taskId: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'UpdateTaskStatusAndPriority',
			Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение подзадач задачи
	 */
	async GetSubtasksAsync(taskId: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetSubtasksAsync',
			Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение задач по тегу
	 */
	async GetTaskByTagAsync(parameters: GetTaskByTagModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetTaskByTagAsync',
			Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление коментария к задаче
	 */
	async CreateCommentTaskAsync(parameters: CreateCommentTaskModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'CreateCommentTaskAsync',
			Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список задач по номеру списка
	 */
	async GetTasksListAsync(listId: ListIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetTasksListAsync',
			Value: typeof(listId) === 'object' ? JSON.stringify(listId) : listId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка комментариев задачи
	 */
	async GetCommentsTaskAsync(taskId: GetCommentsModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetCommentsTaskAsync',
			Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение всех задач из всез team
	 */
	async GetAllTasksAsync() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetAllTasksAsync',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение задач по номеру team
	 */
	async GetTasksTeamAsync(teamId: TeamIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetTasksTeamAsync',
			Value: typeof(teamId) === 'object' ? JSON.stringify(teamId) : teamId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка участников задачи
	 */
	async GetMembersTaskAsync(taskId: TaskIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetMembersTaskAsync',
			Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание папки в пространстве
	 */
	async CreateFolderSpaceAsync(parameters: CreateFolderModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'CreateFolderSpaceAsync',
			Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание тега
	 */
	async CreateTagSpaceAsync(model: TagModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'CreateTagSpaceAsync',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка тегов из пространства
	 */
	async GetTagsSpaceAsync(spaceId: SpaceIdModel) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ServiceClickUpRestApi',
			Method: 'GetTagsSpaceAsync',
			Value: typeof(spaceId) === 'object' ? JSON.stringify(spaceId) : spaceId,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение задачи по ее номеру и загрузка на пм
	 */
	async importTaskFromClickUpAsyncAsync(model: GetTaskModel): Promise<TaskCreateResponse> {
		return new Promise<TaskCreateResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'ImportTaskFromClickUpAsync',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<TaskCreateResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskCreateResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление задачи c clickup и пм
	 */
	async deleteTaskAsyncAsync(taskId: TaskIdModel): Promise<DeletedTaskModel> {
		return new Promise<DeletedTaskModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'DeleteTaskAsync',
				Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
				Callback: (response: WsResponseModelT<DeletedTaskModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as DeletedTaskModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание задачи на clickup и пм
	 */
	async createTaskAsyncAsync(model: CreateTaskModel): Promise<CreatedTaskModel> {
		return new Promise<CreatedTaskModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'CreateTaskAsync',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<CreatedTaskModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CreatedTaskModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление задачи
	 */
	async updateFullTaskAsyncAsync(parameters: UpdateTaskModel): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'UpdateFullTaskAsync',
				Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение всех пространств
	 */
	async getAllSpacesAsyncAsync(): Promise<SpacesModel> {
		return new Promise<SpacesModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetAllSpacesAsync',
				Callback: (response: WsResponseModelT<SpacesModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SpacesModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение всех списков в которых распологаются задачи
	 */
	async getAllListsAsyncAsync(): Promise<ListsModel> {
		return new Promise<ListsModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetAllListsAsync',
				Callback: (response: WsResponseModelT<ListsModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ListsModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменяет текст комментария
	 */
	async updateCommentAsyncAsync(newComment: UpdateCommentTask): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'UpdateCommentAsync',
				Value: typeof(newComment) === 'object' ? JSON.stringify(newComment) : newComment,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление вложения на пм
	 */
	async importAttachmentFromClickUpAsyncAsync(model: ImportAttachmentModel): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'ImportAttachmentFromClickUpAsync',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение приоритета задачи
	 */
	async getPriorityByTaskIdAsyncAsync(model: TaskIdModel): Promise<PriorityModel> {
		return new Promise<PriorityModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetPriorityByTaskIdAsync',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<PriorityModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as PriorityModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение статусов по номеру задачи
	 */
	async getStatusesByTaskIdAsyncAsync(task: TaskIdModel): Promise<StatusesModel> {
		return new Promise<StatusesModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetStatusesByTaskIdAsync',
				Value: typeof(task) === 'object' ? JSON.stringify(task) : task,
				Callback: (response: WsResponseModelT<StatusesModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as StatusesModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получения всех приоритетов сайта clickup
	 */
	async getClickUpPrioritiesAsync(): Promise<Array<PriorityModel>> {
		return new Promise<Array<PriorityModel>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetClickUpPriorities',
				Callback: (response: WsResponseModelT<Array<PriorityModel>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<PriorityModel>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение статусов списка
	 */
	async getStatusesByListIdAsyncAsync(list: ListIdModel): Promise<StatusesModel> {
		return new Promise<StatusesModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetStatusesByListIdAsync',
				Value: typeof(list) === 'object' ? JSON.stringify(list) : list,
				Callback: (response: WsResponseModelT<StatusesModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as StatusesModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение задачи clickup с номерами статуса, приоритета и самой задачи
	 */
	async getClickUpTaskAsyncAsync(taskId: TaskIdModel): Promise<TaskModel> {
		return new Promise<TaskModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetClickUpTaskAsync',
				Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
				Callback: (response: WsResponseModelT<TaskModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение статуса задачи
	 */
	async getStatusTaskAsync(model: GetStatusModel): Promise<StatusModel> {
		return new Promise<StatusModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetStatusTask',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<StatusModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as StatusModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение вложений задачи
	 */
	async getAttachmentsTaskAsyncAsync(model: TaskIdModel): Promise<AttachmentsModel> {
		return new Promise<AttachmentsModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetAttachmentsTaskAsync',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<AttachmentsModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as AttachmentsModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновляет статус задачи
	 */
	async updateTaskStatusAsyncAsync(parameters: UpdateTaskStatusModel): Promise<StatusModel> {
		return new Promise<StatusModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'UpdateTaskStatusAsync',
				Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
				Callback: (response: WsResponseModelT<StatusModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as StatusModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменение приоритета задачи
	 */
	async updateTaskPriorityAsyncAsync(parameters: UpdateTaskPriorityRequest): Promise<UpdatePriorityResponse> {
		return new Promise<UpdatePriorityResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'UpdateTaskPriorityAsync',
				Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
				Callback: (response: WsResponseModelT<UpdatePriorityResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UpdatePriorityResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление статуса и приоритета задачи на пм(изменения применяются если они присутствуют на clickup)
	 */
	async updateTaskStatusAndPriorityAsync(taskId: TaskIdModel): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'UpdateTaskStatusAndPriority',
				Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение подзадач задачи
	 */
	async getSubtasksAsyncAsync(taskId: TaskIdModel): Promise<SubtasksModel> {
		return new Promise<SubtasksModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetSubtasksAsync',
				Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
				Callback: (response: WsResponseModelT<SubtasksModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SubtasksModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение задач по тегу
	 */
	async getTaskByTagAsyncAsync(parameters: GetTaskByTagModel): Promise<TasksModel> {
		return new Promise<TasksModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetTaskByTagAsync',
				Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
				Callback: (response: WsResponseModelT<TasksModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TasksModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление коментария к задаче
	 */
	async createCommentTaskAsyncAsync(parameters: CreateCommentTaskModel): Promise<CreatedCommentModel> {
		return new Promise<CreatedCommentModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'CreateCommentTaskAsync',
				Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
				Callback: (response: WsResponseModelT<CreatedCommentModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CreatedCommentModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список задач по номеру списка
	 */
	async getTasksListAsyncAsync(listId: ListIdModel): Promise<TasksModel> {
		return new Promise<TasksModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetTasksListAsync',
				Value: typeof(listId) === 'object' ? JSON.stringify(listId) : listId,
				Callback: (response: WsResponseModelT<TasksModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TasksModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка комментариев задачи
	 */
	async getCommentsTaskAsyncAsync(taskId: GetCommentsModel): Promise<CommentsModel> {
		return new Promise<CommentsModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetCommentsTaskAsync',
				Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
				Callback: (response: WsResponseModelT<CommentsModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CommentsModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение всех задач из всез team
	 */
	async getAllTasksAsyncAsync(): Promise<TasksModel> {
		return new Promise<TasksModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetAllTasksAsync',
				Callback: (response: WsResponseModelT<TasksModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TasksModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение задач по номеру team
	 */
	async getTasksTeamAsyncAsync(teamId: TeamIdModel): Promise<TasksModel> {
		return new Promise<TasksModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetTasksTeamAsync',
				Value: typeof(teamId) === 'object' ? JSON.stringify(teamId) : teamId,
				Callback: (response: WsResponseModelT<TasksModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TasksModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка участников задачи
	 */
	async getMembersTaskAsyncAsync(taskId: TaskIdModel): Promise<UsersModel> {
		return new Promise<UsersModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetMembersTaskAsync',
				Value: typeof(taskId) === 'object' ? JSON.stringify(taskId) : taskId,
				Callback: (response: WsResponseModelT<UsersModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UsersModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание папки в пространстве
	 */
	async createFolderSpaceAsyncAsync(parameters: CreateFolderModel): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'CreateFolderSpaceAsync',
				Value: typeof(parameters) === 'object' ? JSON.stringify(parameters) : parameters,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание тега
	 */
	async createTagSpaceAsyncAsync(model: TagModel): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'CreateTagSpaceAsync',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка тегов из пространства
	 */
	async getTagsSpaceAsyncAsync(spaceId: SpaceIdModel): Promise<TagsModel> {
		return new Promise<TagsModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ServiceClickUpRestApi',
				Method: 'GetTagsSpaceAsync',
				Value: typeof(spaceId) === 'object' ? JSON.stringify(spaceId) : spaceId,
				Callback: (response: WsResponseModelT<TagsModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TagsModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}